<template>
  <div :class="$setClasses">
    <div :class="$vClass('wrapper')">
      <p :class="$vClass('text')">
        {{ $t('resume.preBooking.dateSubTitle',
          {loadingDate: loadingDate}) }}
      </p>
      <p v-if="!allowDateChange && !dateFixe"
         :class="$vClass('text')">
        {{$t('resume.booking.dateSpecific')}}
      </p>
      <template v-if="allowDateChange">
        <p :class="$vClass('text')">
          <el-checkbox v-model="dateNotSuitable">
              <span>
                {{ $t('resume.preBooking.dateNotSuitable',
                  {otherDate: otherDateText}) }}
              </span>
          </el-checkbox>
        </p>
        <el-date-picker
            :class="$vClass('checkbox')"
            v-if="dateNotSuitable"
            v-model="model"
            :placeholder="$t('resume.preBooking.dateTitle')"
            format="dd/MM/yyyy"
            :picker-options="{ disabledDate }"
            type="date">
        </el-date-picker>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import demand from '@/utils/helpers/demand';
import Input from '@nextories/vue-core-components/src/components/atoms/input/Input.vue';

export default {
  name: 'loadingDate',
  nameClassStyle: 'loading-date',
  extends: Input,
  props: {
    loadDateFrom: String,
    loadDateTo: String,
    allowDateChange: Boolean,
  },
  data() {
    return {
      dateNotSuitable: false,
    };
  },
  computed: {
    ...mapGetters({
      nbDaysBookingLimit: 'projectStore/nbDaysBookingLimit',
    }),
    loadingDate() {
      return demand.formatBetweenDates(
        this.loadDateFrom,
        this.loadDateTo,
      );
    },
    dateFixe() {
      return demand.dateFixe(this.loadDateFrom, this.loadDateTo);
    },
    otherDateText() {
      return this.dateFixe
        ? `${this.$t('base.other')} `
        : '';
    },
  },
  methods: {
    disabledDate(date) {
      return (new Date(date)).getTime() < Date.now();
    },
  },
  watch: {
    dateNotSuitable() {
      this.$emit('changeDateNotSuitable', this.dateNotSuitable);
    },
  },
};
</script>

<style scoped lang="scss">
.loading-date {

  &__text {
    font-size: 15px;

    :deep(.el-checkbox__label) {
      white-space: normal;
      font-size: 15px;
    }
  }
}
</style>
